import AWS from 'aws-sdk';
import { Auth } from 'aws-amplify';

// Initialise le SDK AWS avec les credentials temporaires
export const initAWSSDK = async () => {
  const session = await Auth.currentSession(); // vérifie qu'on est bien connecté
  const credentials = await Auth.currentCredentials();

  AWS.config.update({
    region: process.env.REACT_APP_REGION,
    credentials: Auth.essentialCredentials(credentials),
  });
};
